<template>
  <div class="course-box" @click="toShow()">
    <div class="course-box-body">
      <div
        class="cover-box"
        :style="
          'background-image:url(https://materialresource.xkw.com/' +
          info.coverPath +
          ')'
        "
      >
        <div class="time">
          <template v-if="info.seconds || info.seconds == 0">
            {{ info.seconds | timeChange }}
          </template>
          <template v-else>
            {{ info.lessonSeconds | timeChange }}
          </template>
        </div>
      </div>
      <div class="course-info">
        <p class="course-title" :title="info.title || info.lessonName">
          {{ info.title || info.lessonName }}
        </p>
        <div class="course-bottom">
          <p v-if="currentTab === 3">
            学习时长{{ info.playDurationSeconds | timeChange2 }}
          </p>
          <p v-else>{{ info.playNum | numberChange }}次播放</p>
          <span v-if="info.lessonPercent === 100" class="status-finish"
            >已学完</span
          >
          <span
            v-else-if="currentTab == 3 && info.lessonPercent > 0"
            class="status-progress"
            >已学习{{ info.lessonPercent }}%</span
          >
        </div>
      </div>
    </div>
    <videoPlayer
      v-if="showVideo"
      :video-info="info"
      @closePlayer="closePlayer"
    />
    <auth-dialog
      :dialog-visible.sync="auth.flag"
      :tip-type="auth.tipType"
    ></auth-dialog>
  </div>
</template>

<script>
import numberHandler from "../../mixin/numberHandle";
import videoPlayer from "./video-player.vue";
import AuthDialog from "@/components/auth-dialog.vue";
import { isOpenPermissionDialog } from "@/assets/js/utils";
export default {
  name: "ShopCenterAdminWebCourseItem",
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    currentTab: {
      type: Number,
      default: 1,
    },
  },
  components: {
    videoPlayer,
    AuthDialog,
  },
  mixins: [numberHandler],
  data() {
    return {
      showVideo: false,
      auth: {
        flag: false,
        tipType: null,
      },
    };
  },
  filters: {
    // 处理视频时长
    timeChange: (val) => {
      if (val == 0) return "00:00";
      let m = Math.floor((val % 3600) / 60);
      let s = val % 60;
      return `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`;
    },
    // 处理学习时长
    timeChange2: (val) => {
      if (val == 0) return "00:00";
      let h = Math.floor(val / 3600);
      let m = Math.floor((val % 3600) / 60);
      let s = val % 60;
      return `${h < 10 ? "0" + h : h}:${m < 10 ? "0" + m : m}:${
        s < 10 ? "0" + s : s
      }`;
    },
  },

  mounted() {},

  methods: {
    toShow() {
      //  auth start;
      const type = isOpenPermissionDialog(this.$store.state.user.userInfo);
      if (type === 1 || type === 3) {
        this.auth.tipType = type;
        this.auth.flag = true;
        return;
      }
      //  auth end;
      this.showVideo = true;
    },
    closePlayer() {
      // 提示父组件刷新数据
      this.$emit("refresh");
      this.showVideo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.course-box {
  // min-width: 200px;
  // max-width: 290px;
  // height: 240px;
  // // margin-right: 20px;
  // border-radius: 7px;
  // background: #f6f6f6;
  // overflow: hidden;
  // cursor: pointer;
  .course-box-body {
    min-width: 200px;
    max-width: 290px;
    width: 100%;
    height: 240px;
    border-radius: 7px;
    background: #f6f6f6;
    overflow: hidden;
    cursor: pointer;
  }
  .cover-box {
    position: relative;
    width: 100%;
    height: 154px;
    background-size: 100% 100%;
    transform: scale(1);
    transition: all 0.25s linear;
    &:hover {
      transform: scale(1.05);
    }
    .time {
      position: absolute;
      right: 10px;
      bottom: 10px;
      padding: 2px 10px;
      border-radius: 9px;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 13px;
    }
  }
  .course-info {
    padding: 0 16px;
    .course-title {
      margin: 16px 0 20px 0;
      color: #3a3d4b;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      // 两行超出省略
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // word-break: break-all;
    }
    .course-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      & > p {
        color: #8895a9;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
      }
      .status-finish {
        color: #00a843;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
      }
      .status-progress {
        color: #f58800;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
      }
    }
  }
}
</style>
